import { type DrawDefinition, type StageTypeEnum } from '@clubspark-node/clubspark-tennis-types';

import { type FlightProfile } from 'typedefs/store/tmxTypes';

export const getIsDrawStageGenerated = (
  drawDefinitions: DrawDefinition[],
  structureStage: StageTypeEnum.MAIN | StageTypeEnum.QUALIFYING,
) => {
  return !!drawDefinitions?.some((drawDefinition) =>
    drawDefinition?.structures?.some((structure) => structure?.stage === structureStage),
  );
};

export const getIsParticipantAssignedToDraw = (
  participantId: string,
  eventFlights: FlightProfile[],
  stage: StageTypeEnum,
) =>
  eventFlights.some((flight) =>
    flight.drawDefinition?.structures?.some(
      (structure) =>
        structure?.stage === stage &&
        (structure?.structures?.length
          ? structure.structures.some((s) =>
              s.positionAssignments?.some((position) => position.participantId === participantId),
            )
          : structure.positionAssignments?.some((position) => position.participantId === participantId)),
    ),
  );
